import { render } from "./TitleHolder.vue?vue&type=template&id=39d10681&scoped=true"
const script = {}

import "./TitleHolder.vue?vue&type=style&index=0&id=39d10681&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d10681"]])

export default __exports__